import axios from "axios";

const URL = 'https://api.openweathermap.org/data/2.5/weather';
const fetchWeather = async (query) => {

    const { data } = await axios.get(URL, {
        params: {
            q: query,
            units: "metric",
            APPID: 'b692f55db5f9d95be92f79ef9351a1b3',
        },
    });

    return data;
};

export default fetchWeather;
